import { Controller } from "react-hook-form";
import { Checkbox, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps } from "@mui/material";
import { ReactHookFormBaseProps } from "../../types/ReactHookForm/ReactHookFormBaseElement";

export type SelectOption = {
  id: string | number;
  label: string;
};

export type SelectElementProps = {
  label: string;
  options: SelectOption[];
  showCheckbox?: boolean;
  helperText?: string;
  onChange?: SelectProps["onChange"];
} & ReactHookFormBaseProps &
  Omit<SelectProps, "value" | "children" | "name" | "error" | "onChange">;

//todo remove old SelectElement and replace with this one everywhere
//todo also rename this to SelectElement since its just that
//be aware of updated handling values in options instead of children
export default function MultiSelectElement({
  name,
  label,
  options,
  rules,
  showCheckbox = true,
  helperText = "",
  disabled = false,
  multiple = false,
  fullWidth = true,
  onChange,
  sx,
  ...rest
}: SelectElementProps) {
  return (
    <Controller
      name={name}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const value = field.value ?? (multiple ? [] : "");

        return (
          <FormControl fullWidth={fullWidth} disabled={disabled} error={!!error} sx={{ margin: "1rem 0 0.5rem", ...sx }}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
              {...rest}
              {...field}
              labelId={`${name}-label`}
              multiple={multiple}
              label={label}
              value={value}
              onChange={(event, child) => {
                field.onChange(event);
                if (onChange) {
                  onChange(event, child);
                }
              }}
            >
              {options.map((option) => {
                const isSelected = multiple
                  ? Array.isArray(value) && value.indexOf(option.id) > -1
                  : value === option.id;
                return (
                  <MenuItem key={option.id} value={option.id}>
                    {multiple && showCheckbox && <Checkbox checked={isSelected} />}
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
            {(!!error || helperText) && <FormHelperText>{error?.message || helperText}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
}
